import React from 'react';

import { Flex, rem, Text } from '@vimeo/bokeh';
import { Building } from '@vimeo/bokeh-icons';

import { SEAT_TIER_PLANS, PLANS } from '../../../utils/constants';
import { PlanData } from '../../../utils/interface';
import translations from '../../../utils/translations';
import { getPlanBillingFrequencyCopy, getPlanDisplayPrice } from '../../../utils/utils';

interface Props {
  planData: PlanData;
  displayMonthlyPlan: boolean;
}

const PlanCardPrice = ({ planData, displayMonthlyPlan }: Props) => {
  const { entitlements } = planData.metadata;
  const isBandwidthProduct = planData.metadata.isBandwidthProduct;

  return (
    <Flex
      flexDirection="column"
      gap={{ base: 'xs', md: 'sm', xl: 'xs' }}
      minHeight={{ base: 'initial', xl: rem(80) }}
      maxHeight={{ base: 'initial', xl: rem(80) }}
    >
      {planData.tier === PLANS.ENTERPRISE ? (
        <>
          <Text variant={{ base: 'heading-xl', md: 'heading-2xl', xl: 'heading-xl' }}>
            <Building h={rem(40)} w={rem(40)} />
          </Text>
          <Text
            variant={{ base: 'body-sm', md: 'body-md', xl: 'body-sm' }}
            textColor="text-secondary"
            marginBottom={{ base: 'md', md: 'sm', xl: 'md' }}
          >
            {translations.talkToTeam}
          </Text>
        </>
      ) : (
        <>
          <Text variant={{ base: 'heading-xl', md: 'heading-2xl', xl: 'heading-xl' }}>
            {getPlanDisplayPrice(planData, displayMonthlyPlan, isBandwidthProduct)}
          </Text>
          <Text
            variant={{ base: 'body-sm', md: 'body-md', xl: 'body-sm' }}
            textColor="text-secondary"
            marginBottom={{ base: 'md', md: 'sm', xl: 'md' }}
          >
            {!isBandwidthProduct ? (
              <>
                {SEAT_TIER_PLANS.includes(planData.tier)
                  ? entitlements?.params?.videoStorageQuotaUnit === 'video_size'
                    ? translations.perMonthBilledAnually
                    : translations.perSeatPerMonth
                  : translations.perMonth}
                <br />
              </>
            ) : null}
            {getPlanBillingFrequencyCopy(displayMonthlyPlan, planData, isBandwidthProduct)}
          </Text>
        </>
      )}
    </Flex>
  );
};

export default PlanCardPrice;
